import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const MenuIcon = ({ className, onClick }: Props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
      <line x1="4" y1="7.90005" x2="20" y2="7.90005" stroke="#0C0F24" strokeWidth="1.5"/>
      <line x1="4" y1="14.6" x2="18.1176" y2="14.6" stroke="#0C0F24" strokeWidth="1.5"/>
    </svg>
  );
};

export default MenuIcon;